import React from "react";
import { faq } from "../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function Faq() {
  return (
    <section id="faq" className="bg-[#F4F0E9] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <div>
            <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
              <span className="h-px w-8 bg-[#B08D57]" /> Questions fréquentes
            </p>
            <h2 className="font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[44px]">
              Des réponses claires avant de nous confier votre bien.
            </h2>
            <p className="mt-4 text-[16px] leading-relaxed text-[#6e6a62]">
              Votre interlocuteur, les honoraires, le choix du locataire et la reprise de votre bien : l'essentiel pour avancer en confiance.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faq.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#ddd4c3]">
                <AccordionTrigger className="py-5 text-left text-[17px] font-semibold text-[#26241F] hover:no-underline hover:text-[#B08D57]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#6e6a62]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
